import { PayloadAction } from '@reduxjs/toolkit';
import { PlanboardState } from '@reducers/v2/planboard/types';

// optimisticFields only set by the finishProductionOperation thunk; SignalR carries productionOperationId only.
export const onClosedProductionOperationAction = (
  state: PlanboardState,
  action: PayloadAction<{
    productionOperationId: number;
    optimisticFields?: {
      actualEndDate: string;
      actualQuantity: number;
    };
  }>
) => {
  const { productionOperationId } = action.payload;
  state.lastClosedSnapshot = null;
  Object.entries(state.machineProductionOperations).forEach(([columnId, column]) => {
    const idx = column.items.findIndex((item) => item.productionOperationId === productionOperationId);
    if (idx !== -1) {
      state.lastClosedSnapshot = { item: column.items[idx], columnId: Number(columnId), index: idx };
      column.items.splice(idx, 1);
      column.total = column.items.length;
    }
  });
  state.lastCloseError = null;
};
